<template>
  <div>
    <el-dialog
      :visible.sync="showAiDialog"
      :custom-class="{ 'ai-dialog': true, 'full': isAiDialogFull }"
      :width="(iframeWidth + 10) + 'px'"
      :modal="false"
      :append-to-body="true"
      :show-close="false"
      :center="false"
    >
      <div slot="title" class="dialog-header">
        <div class="header-title">
          <img class="header-logo" src="../assets/images/ai-dialog-logo.png" alt="">
          <span>科创AI专家</span>
        </div>
        <div class="header-buttons">
          <i class="el-icon-link" @click="handleAiDialog('open')"></i>
          <i class="el-icon-full-screen" @click="handleAiDialog('big')"></i>
          <i class="el-icon-minus" @click="handleAiDialog('small')"></i>
          <i class="el-icon-close" @click="handleAiDialog('close')"></i>
        </div>
      </div>
      <iframe src="https://www.hnkczx.cn:8094/pophome" :width="iframeWidth" :height="iframeHeight" frameborder="0"></iframe>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'AiDialog',
  data() {
    return {
      showAiDialog: false,
      isAiDialogFull: false,
      iframeWidth: 450,
      iframeHeight: 650,
    }
  },
  methods: {
    show(){
      this.showAiDialog = true
    },
    // 科创ai弹窗事件
    handleAiDialog(type){
      switch(type){
        case 'open':
          window.open("https://www.hnkczx.cn:8094/", '_blank');
          break;
        case 'big':
          if(!this.isAiDialogFull){
            this.iframeWidth = 1200
            this.isAiDialogFull = true
          }
          break;
        case 'small':
          if(this.isAiDialogFull){
            this.iframeWidth = 450
            this.isAiDialogFull = false
          }
          break;
        case 'close':
          this.showAiDialog = false
          this.isAiDialogFull = false
          break;
      }
    },
  },
}
</script>
<style lang='scss'>
.ai-dialog{
  margin: 0 !important;
  position: fixed !important;
  right: 6rem;
  bottom: 3.5rem;
  border-radius: 10px !important;
  &.full{
    margin: 15vh auto 0 auto !important;
    position: relative !important;
    right: unset;
    bottom: unset;
  }
  .el-dialog__header{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 0 !important;
    background-image: url('../assets/images/ai_dialog_header_bg.png');
    background-size: 100% 100%;
    width: 100%;
    height: 50px;
  }
  .dialog-header{
    width: calc(100% - 35px);
    height: 50px;
    padding-left: 20px;
    padding-right: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-title{
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN;
      font-weight: 700;
      font-size: 20px;
      color: #323234;
      .header-logo{
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .header-buttons{
      i{
        margin-left: 15px;
        width: 20px;
        height: 20px;
        font-size: 26px;
        color: #333;
        cursor: pointer;
      }
    }
  }
  .el-dialog__body {
    padding: 5px !important;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}
</style>